/** Canonical production storefront URL */
export const SITE_URL = (
  process.env.REACT_APP_SITE_URL || "https://oorilabel.com"
).replace(/\/$/, "");

/** Render-hosted FastAPI backend */
export const RENDER_API_URL = "https://oori-label-api.onrender.com";

export const SITE_NAME = "Oori Label";

export const isRenderApiUrl = (url) =>
  typeof url === "string" && url.includes("onrender.com");
